import styled from "styled-components";

const FranceWrapper = styled.div`
    max-width: 900px;
    margin: 60px auto 30px;
    padding: 30px 20px;
    background-color: #e6e6e6;
    border-radius: 15px;
    box-shadow: 0 8px 12px rgba(0, 0, 0, 0.4);
`;

const FranceHeaderText = styled.h1`
    text-align: center;
    font-size: 32px;
    margin-bottom: 20px;
    color: #007bff;
    font-weight: bold;
`;

const FranceTextContent = styled.div`
    font-size: 20px;
    line-height: 1.8;
    color: #4a4a4a;

    p {
        margin-bottom: 15px;
    }

    strong {
        color: #007bff;
    }
`;

const TermsAndConditions = () => {
  return (
    <>
      <FranceWrapper>
        <FranceHeaderText>Nouveaux Termes et Conditions de France Investment</FranceHeaderText>
        <FranceTextContent>
          <p>
            Bienvenue chez France Investment. En accédant à notre plateforme, vous acceptez ces termes et conditions, qui peuvent être mis à jour à tout moment sans préavis. Nous vous recommandons de les consulter périodiquement pour rester informé.
          </p>
          <p>
            <strong>1. Utilisation de la plateforme :</strong> L'utilisateur s'engage à utiliser la plateforme de manière éthique et conformément à la législation en vigueur. Il est interdit d'utiliser la plateforme pour des activités pouvant compromettre la sécurité ou l'intégrité des informations.
          </p>
          <p>
            <strong>2. Droits de propriété :</strong> Tout le contenu, y compris les textes, images, logos et logiciels, est la propriété exclusive de France Investment et est protégé par les lois sur la propriété intellectuelle.
          </p>
          <p>
            <strong>3. Limitation de responsabilité :</strong> France Investment n'est pas responsable des dommages directs, indirects ou consécutifs résultant de l'utilisation ou de l'incapacité à utiliser la plateforme.
          </p>
          <p>
            <strong>4. Mises à jour et modifications :</strong> Nous nous réservons le droit de modifier, mettre à jour ou supprimer toute partie de ces termes à tout moment sans préavis. L'utilisation continue de la plateforme implique l'acceptation de ces modifications.
          </p>
          <p>
            <strong>5. Législation et juridiction :</strong> Ces termes seront régis et interprétés conformément à la loi française. En cas de litige, les deux parties se soumettront à la juridiction exclusive des tribunaux de Paris.
          </p>
          <p>
            Si vous avez des questions ou avez besoin de plus d'informations, n'hésitez pas à nous contacter.
          </p>
        </FranceTextContent>
      </FranceWrapper>
    </>
  );
};
export default TermsAndConditions;